import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import setModalDataAction from '../actions/setModalData'
import Title from '../components/Title.jsx'
import Button from '../components/Button.jsx'
import ReferencesList from '../components/ReferencesList.jsx'
import setAllReferencesData from '../actions/setAllReferencesData'
import getAllReferences from '../api/getAllReferences'
import getOneReference from '../api/getOneReference'
import ModalContainer from '../containers/ModalContainer.jsx'

class SmallReferencesContainer extends Component {
    componentDidMount() {
        getAllReferences()
            .then((data) => {
                setTimeout(() => {
                    this.props.setAllReferencesData(data.slice(0, 2))
                }, 500)
            }).catch(() => {

            })
    }

    componentWillUnmount() {
        this.props.setAllReferencesData([])
    }

    static modalFetch = (store, params) => {
        const id = parseInt(params.id, 10) || -1
        if (id !== -1) {
            return getOneReference(id)
                .then((data) => {
                    store.dispatch(setModalDataAction(data))
                }).catch(() => {})
        }
        return Promise.resolve()
    }

    setModalData = (data) => {
        this.props.setModalDataAction(data)
    }

    render() {
        return (
            <div className="small-references-container section-spacing--big-nobottom">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <Title title={this.props.langData.referencesTitle} />
                        </div>
                        <ReferencesList
                            itemsData={this.props.referencesData}
                            path="/pocetna/reference"
                            setModalData={this.setModalData}
                        />
                        <div className="small-references-button">
                            <Button
                                type="yellow"
                                text={this.props.langData.referencesButton}
                                link="/reference"
                            />
                        </div>
                        <Route
                            exact
                            path="/pocetna/reference/:id"
                        >
                            <ModalContainer data={this.props.modalData} />
                        </Route>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    langData: state.langData.landing,
    referencesData: state.allReferencesData,
    modalData: state.modalData
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setAllReferencesData,
    setModalDataAction
}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SmallReferencesContainer))



// WEBPACK FOOTER //
// ./src/scripts/containers/SmallReferencesContainer.jsx